import { ChangeEvent } from 'react';

import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

import { AppDispatch } from '../../../store/models/app-dispatch.model';
import { PaginationDefaultsModel } from '../../models/pagination-defaults.model';
import { PaginationDefaults } from '../pagination-defaults.util';

export const onChangeTableRowsPerPage = (
  dispatch: AppDispatch,
  addPaginationAction: ActionCreatorWithPayload<
    PaginationDefaultsModel,
    string
  >,
  callbackFn?: () => void
): ((event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void) => {
  return (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    callbackFn?.();
    dispatch(
      addPaginationAction({
        totalCount: PaginationDefaults.totalCount,
        pageNumber: PaginationDefaults.pageNumber,
        size: parseInt(event.target.value, 10),
        offset:
          parseInt(event.target.value, 10) * PaginationDefaults.pageNumber,
      })
    );
  };
};
